exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/monitoring/actual/politicallyexposed/politicallyexposedinfo/politically-exposed-info.component.css
// module id = 1964
// module chunks = 0